export const BUTTON_TYPE_PRIMARY = 'primary'
export const BUTTON_TYPE_SUCCESS = 'success'
export const BUTTON_TYPE_WARNING = 'warning'
export const BUTTON_TYPE_DANGER = 'danger'
export const BUTTON_TYPE_INFO = 'info'
export const BUTTON_TYPE_TEXT = 'text'

export const BUTTON_NATIVE_TYPE_BUTTON = 'button'
export const BUTTON_NATIVE_TYPE_SUBMIT = 'submit'
